export const VehicleDetailsLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    EXPAND: 'EXPAND',
};
